(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nees-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => { if(event.key !== 'Escape') return; const menu = document.querySelector('.nees-mobile-nav[open]'); if(menu){menu.removeAttribute('open');menu.querySelector('summary').focus();} });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nees-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nees-video-observer')) {
    class NeesVideoObserver extends HTMLElement {}
    customElements.define('nees-video-observer', NeesVideoObserver);
    const setup = (root) => {
      root.querySelectorAll('.nees-videos video:not([data-nees-ready])').forEach((video) => {
        video.dataset.neesReady = 'true';
        video.muted = true;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        let manuallyPaused = false;
        let visible = false;
        let autoPausing = false;
        video.addEventListener('pause', () => {
          if (!autoPausing && visible && !document.hidden) manuallyPaused = true;
          autoPausing = false;
        });
        video.addEventListener('play', () => { manuallyPaused = false; });
        const update = () => {
          if (visible && !document.hidden && !reduced.matches && !manuallyPaused) {
            video.play().catch(() => {});
          } else if (!video.paused && (!visible || document.hidden || reduced.matches)) {
            autoPausing = true;
            video.pause();
          }
        };
        const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; update(); }, {threshold: 0.4});
        observer.observe(video);
        document.addEventListener('visibilitychange', update);
        reduced.addEventListener('change', update);
      });
    };
    setup(document);
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  }

  } catch(e) { console.error(e); }
})();
})();
